import { RowAction } from '@ver-uds/react/dist/Table/Table';
import { HiringSite } from 'eve-account-client';
import type { Row, Column } from 'react-table';
import OpenModalType from '../OpenModalType';

export type TableData = {
  line1: string;
  line2?: string;
  city: string;
  zipCode: string;
  stateCode: string;
  id?: string;
};

const shortAddress = (address: Record<string, unknown>): string => {
  return `${String(address.line1)} ${address.line2 ? `${String(address.line2)} ` : ''}${String(address.city)}`;
};

function rowActions(onModalOpen: (hiringSite: HiringSite, modalType: OpenModalType) => void): RowAction<TableData>[] {
  return [
    {
      handler: (row: Row<TableData>): void => {
        onModalOpen(row.original, OpenModalType.EDIT);
      },
      icon: 'edit',
      label: ({ values: address }: Row<TableData>): string => {
        return `Open modal to edit ${shortAddress(address)}`;
      },
    },
    {
      handler: (row: Row<TableData>): void => {
        onModalOpen(row.original, OpenModalType.ADD);
      },
      icon: 'content_copy',
      label: ({ values: address }: Row<TableData>): string => {
        return `Open modal to duplicate ${shortAddress(address)}`;
      },
    },
    {
      handler: (row: Row<TableData>): void => {
        onModalOpen(row.original, OpenModalType.DELETE);
      },
      icon: 'delete',
      label: ({ values: address }: Row<TableData>): string => {
        return `Open modal to delete ${shortAddress(address)}`;
      },
    },
  ];
}

const columns: Column<TableData>[] = [
  {
    Header: 'Street Address',
    accessor: 'line1',
    minWidth: 226,
  },
  {
    Header: 'Suite/Other',
    accessor: 'line2',
    minWidth: 226,
  },
  {
    Header: 'City',
    accessor: 'city',
    minWidth: 168,
  },
  {
    Header: 'Zip Code',
    accessor: 'zipCode',
    minWidth: 168,
  },
];

export { rowActions, columns };
